import React from 'react';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';

function MatchChip({ match, type }) {
  const { t } = useTranslation('matchChip');
  const classes = useStyles();

  const defineClassName = type => {
    if (type === 'positionAbsolute') {
      return clsx(classes.matchChip, classes.positionAbsolute);
    }

    if (type === 'silverBgColor') {
      return clsx(classes.matchChip, classes.silverBgColor);
    }

    if (type === 'productCard') {
      return clsx(classes.matchChip, classes.productCard);
    }

    return classes.matchChip;
  };

  const certainClassName = defineClassName(type);

  return (
    <Typography className={certainClassName}>
      {`${t('match')}${Math.round(match)}%`}
    </Typography>
  );
}

export default MatchChip;
